import { NEW_DATA_ENTRY, NEW_QA_REVIEW } from "../../../../routeNames.js";

export const adjustmnetsgroupCode = [
  { value: "CO", label: "CO" },
  { value: "OA", label: "OA" },
  { value: "PI", label: "PI" },
  { value: "PR", label: "PR" }
];

export const serviceLineProcedureType = [
 { value: "HC", label: "HC" },
  { value: "NU", label: "NU" },
  { value: "AD", label: "AD" }
];

export const claimStatusCode = [
  { value: "1", label: "1 Primary" },
  { value: "2", label: "2 Secondary" },
  { value: "3", label: "3 Tertiary" },
  { value: "4", label: "4 Denial" },
  { value: "22", label: "22 Reverse" },
  { value: "19", label: "19 Primary Forwarded" },
  { value: "20", label: "20 Secondary Forwarded" },
  { value: "21", label: "21 Tertiary Forwarded" },
  { value: "23", label: "23 Not Our Claim Forwarded" },
  { value: "25", label: "25 Predetermination - No Payment" },
];

export const paymentMethodOptions = [
  { value: "ACH", label: "ACH" },
  { value: "CHK", label: "CHK" },
  { value: "NON", label: "NON" },
  { value: "VCP", label: "VCP" },
  { value: "OTH", label: "OTH" },
  { value: "CCI", label: "CCI" },
  { value: "COR", label: "COR" }
];

export const creditCardPaymentMethodOptions = [
  { value: "1", label: "Visa" },
  { value: "2", label: "MasterCard" },
  { value: "3", label: "Discover" },
  { value: "4", label: "Other" },
  { value: "5", label: "Amex" }
];

export const paymentSourceOptions = [
  { value: "CASH", label: "CASH" },
  { value: "CHECK", label: "CHECK" },
  { value: "CREDIT_CARD", label: "CREDIT CARD" },
  { value: "MONEY_ORDER", label: "MONEY ORDER" }
];

export const plbReasonOptions = [
  // { value: "", label: "---Select---" },
  { value: "L6", label: "L6 - Interest" },
  { value: "WO", label: "WO - Overpayment Recovery" },
  { value: "FB", label: "FB - Forward Balance" },
  { value: "BD", label: "BD - Bad Debt" },
  { value: "72", label: "72 - Authorized Return" },
  { value: "BN", label: "BN - Bonus" },
  { value: "CS", label: "CS - Adjustment" },
  { value: "AH", label: "AH - Origination" },
  { value: "AM", label: "AM - Borrower's Account" },
  { value: "AP", label: "AP - Acceleration of Benefits" },
  { value: "B2", label: "B2 - Rebate" },
  { value: "B3", label: "B3 - Recovery" },
  { value: "C5", label: "C5 - Temporary Allowance" },
  { value: "CR", label: "CR - Capitation Interest" },
  { value: "CT", label: "CT - Capitation Payment" },
  { value: "CV", label: "CV - Capital Passthru" },
  { value: "CW", label: "CW - Registered Nurse Passthru" },
  { value: "DM", label: "DM - Direct Medical Passthru" },
  { value: "E3", label: "E3 - Withholding" },
  { value: "FC", label: "FC - Fund Allocation" },
  { value: "GO", label: "GO - Graduate Passthru" },
  { value: "HM", label: "HM - Hemophilia Clotting" },
  { value: "IP", label: "IP - Incentive Payment" },
  { value: "IR", label: "IR - IRS withholding" },
  { value: "IS", label: "IS - Interim Settlement" },
  { value: "J1", label: "J1 - Nonreimbursable" },
  { value: "L3", label: "L3 - Penalty" },
  { value: "LE", label: "LE - Levy" },
  { value: "LS", label: "LS - Lump Sum" },
  { value: "OA", label: "OA - Organ Passthru" },
  { value: "OB", label: "OB - Provider Offset" },
  { value: "PI", label: "PI - Periodic Payment" },
  { value: "PL", label: "PL - Final Payment" },
  { value: "RA", label: "RA - Retroactive Adjustment" },
  { value: "RE", label: "RE - Return on Equity" },
  { value: "SL", label: "SL - Student Loan Repayment" },
  { value: "TL", label: "TL - Third Party Liability" },
  { value: "WU", label: "WU - Unspecified Recovery" },
  { value: "50", label: "50 - Late charge" },
  { value: "51", label: "51 - Interest" },
  { value: "90", label: "90 - Early Payment" },
];



const addEditedData = (obj) => {
  const result = {};
  for (const key in obj) {
    const value = obj[key];

    // Skip unwanted keys
    if (["job", "client_id", "reference_entity_identifier", "payee_pulled_id" ,
      "payer_id","payer_pulled_id","claim_id","encounter","patient_id","subscriber_id","rendering_provider_id",
      "service_line_id",].includes(key)) {
      continue;
    }

    if (Array.isArray(value)) {
      // If it's an array, recurse for each item
      result[key] = value.map(item => addEditedData(item));
    } else if (value !== null && typeof value === "object") {
      // If it's an object, recurse
      result[key] = addEditedData(value);
    } else {
      // For primitive values
      result[key] = value;
    }
  }

  // Add edited_data for all keys in this object
  const editedData = {};
  Object.keys(result).forEach(k => {
    editedData[k] = { old_val: null, error: true };
  });
  result.edited_data = editedData;

  return result;
};
const createEditedData = (obj, excludedKeys=[]) => {
  const edited = window.location.pathname === NEW_QA_REVIEW?{is_new:true,}:{};
  
  Object.keys(obj).forEach((key) => {
    // skip arrays for now
    if (Array.isArray(obj[key]) || excludedKeys?.includes(key)) return;
    edited[key] = window.location.pathname === NEW_QA_REVIEW 
      ? { old_val: null, error: true } 
      : {};
  });
  
  return edited;
}
// Recursive function to add edited_data
export const addEditedDataRecursive = (data,excludedKeys=[]) => {
  if (Array.isArray(data)) {
    return data.map((item) => addEditedDataRecursive(item,excludedKeys=[]));
  } else if (typeof data === "object" && data !== null) {
    const newObj = { ...data };
    // add edited_data for current object
    newObj.edited_data = createEditedData(newObj ,excludedKeys);

    // recursively handle arrays inside the object
    Object.keys(newObj).forEach((key) => {
      if (Array.isArray(newObj[key])) {
        newObj[key] = newObj[key].map((item) => addEditedDataRecursive(item ,excludedKeys=[]));
      }
    });

    return newObj;
  }
  return data;
};
 const initialGridDataSkelton   = {
  job: "",
  client_id: "",
  rejection_reason: "",
  payment_id: "",
//   transaction_type: "PAYMENT835",
  payment_method: "",
  credit_card_payment_method: "",
  payment_source: "",
//   is_first_sub_job: true,
  check_number: "",
  check_date: "",
  check_amount: "",
  remaining_balance: "",
  check_page_number: "",
  correspondance: "",
  reference_entity_identifier: "",
//   grid_customization: "NORMAL",
  qdx_tranansaction_type: "",
  qdx_status: "",
  qdx_reason: "",
  qdx_classification: "",
  payee_id: "",
  payee_pulled_id: "",
  payee_name: "",
  payee_npi: "",
  payee_address: "",
  payee_city: "",
  payee_state: "",
  payee_zip: "",
  payee_page_from: "1",
  payee_page_to: "1",
  payer_id: "",
  payer_pulled_id: "",
  payer_name: "",
  payer_address: "",
  tax_identification_number: "",
  payer_city: "",
  payer_state: "",
  payer_zip: "",
  payer_page_from: "1",
  payer_page_to: "1",
  plb_adjustments: [],
  claims: [
    {
      encounter: "",
      claim_id: "",
      patient: true,
      subscriber: true,
      rendering_provider: true,
      patient_account_number: "",
      payer_claim_number: "",
      period_start: "",
      period_end: "",
      status_code: "",
      mrn: "",
      statement_number: "",
      statement_date: "",
      page_from: "1",
      page_to: "1",
      claim_billed: "",
      claim_discount: "0.00",
      claim_allowed: "0.00",
      claim_deduct: "0.00",
      claim_coins: "0.00",
      claim_copay: "0.00",
      adjustment_total: "0.00",
      claim_adjustment_total: "0.00",
      claim_adjustment_total_pr: "0.00",
      claim_cob: "0.00",
      claim_patres: "0.00",
      claim_paid: "",
      claim_balance: "0.00",
      sl_billed: "0.00",
      sl_discount: "0.00",
      sl_allowed: "0.00",
      sl_deduct: "0.00",
      sl_coins: "0.00",
      sl_copay: "0.00",
      sl_cob: "0.00",
      sl_patres: "0.00",
      sl_amount: "0.00",
      sl_paid: "0.00",
      sl_balance: "0.00",
      sl_total: "0.00",
      patient_id: "",
      patient_first_name: "",
      patient_middle_name: "",
      patient_last_name: "",
      patient_identifier_code: "",
      prior_auth_code: "",
      subscriber_id: "",
      subscriber_first_name: "",
      subscriber_middle_name: "",
      subscriber_last_name: "",
      subscriber_identifier_code: "",
      rendering_provider_id: "",
      rendering_provider_first_name: "",
      rendering_provider_last_name: "",
      rendering_provider_identifier_code: "",
      service_lines: [
        {
          service_line_id: "",
          from_date: "",
          to_date: "",
          code: "",
          procedure_type: "HC",
          modifier1: "",
          modifier2: "",
          modifier3: "",
          modifier4: "",
          rev_code: "",
          units: "",
          patres: "",
          billed: "",
          discount: "",
          allowed: "",
          deduct: "",
          coins: "",
          copay: "",
          cob: "",
          paid: "",
          balance: "",
          adjustments: [
            {
            pc: "",
            group_code: "",
            reason_code: "",
            rmk: "",
            amount: "",
            description: ""
          }
          ]
        }
      ],
      claim_adjustments: [
        {
            pc: "",
            group_code: "",
            reason_code: "",
            rmk: "",
            amount: "",
            description: ""
          }
      ]
    }
  ]
};
export const initialGridData = window.location.pathname === NEW_QA_REVIEW ? addEditedData(initialGridDataSkelton) : initialGridDataSkelton;

export const initialCorresValues =  addEditedDataRecursive({
                is_plb_clear_all: true,
                is_claim_clear_all: true,
                total_plb:0,
                job: "",
                rejection_reason: "",
                payment_id: "",
                transaction_type: "CORRESPONDENCE",
                // is_first_sub_job: isFirstJob,
                payer_name: "",
                letter_date: "",
                correspondance: "",

                qdx_status: "",
                qdx_reason: "",
                qdx_classification: "",
                payer_page_from: "1",
                payer_page_to: "1",

                claims: [
                    {
                        edited: true,
                        claim_id: "",
                        order: "1",
                        patient_account_number: "",
                        period_start: "",
                        period_end: "",
                        billed: "",
                        
                        patient_id: "",
                        patient_first_name: "",
                        patient_middle_name: "",
                        patient_last_name: "",

                        page_from: "1",
                        page_to: "1",
                    },
                ],
            },['job',
'payment_id',
'transaction_type',
'claim_id',
'order',
'patient_id',
'is_plb_cleare_all',
'is_plb_claim_all'
])

// Usage
export const initial835LiteValues = addEditedDataRecursive({
  job: "",
  client: "",
  payment_id: "",
  transaction_type: "PAYMENT835_LITE",
  payment_method: "",
  remaining_balance: "",
  check_number: "",
  check_date: "",
  check_amount: "",
  payer_id: "",
  payer_name: "",
  payee_id: "",
  payee_name: "",

  grid_customization: "NORMAL",

  qdx_status: "",
  qdx_reason: "",
  qdx_classification: "",

  payee_page_from: "1",
  payee_page_to: "1",
  payer_page_from: "1",
  payer_page_to: "1",

  plb_adjustments: [],

  claims: [
    {
      edited: true,
      claim_id: "",
      order: "",
      patient_id: "",
      patient_account_number: "",
      patient_first_name: "",
      patient_middle_name: "",
      patient_last_name: "",
      page_from: "1",
      page_to: "1",
      service_lines: [
        {
          edited: true,
          service_line_id: "",
          period_start: "",
          period_end: "",
          billed: "",
          paid: "",
        },
      ],
    },
  ],
},['service_line_id','edited','claim_id','order','patient_id','job',
'client',
'payment_id',
'transaction_type',
'remaining_balance',
'payer_id',
'payee_id',
'grid_customization',]);

// Keys to exclude at each level
const claimKeysToExclude = ["claim_id", "patient_id", "subscriber_id", "rendering_provider_id"];
const serviceLineKeysToExclude = ["service_line_id"];
const adjustmentKeysToExclude = ["adjustment_id"];
const claimAdjustmentKeysToExclude = ["claim_adjustment_id"];

export const initialClaim = [
  {
    edited: true,
    encounter: "",
    claim_id: "",
    patient: true,
    subscriber: true,
    rendering_provider: true,
    patient_account_number: "",
    payer_claim_number: "",
    period_start: "",
    period_end: "",
    status_code: "",
    mrn: "",
    statement_number: "",
    statement_date: "",
    page_from: "1",
    page_to: "1",
    claim_billed: "",
    claim_discount: "0.00",
    claim_allowed: "0.00",
    claim_deduct: "0.00",
    claim_coins: "0.00",
    claim_copay: "0.00",
    adjustment_total: "0.00",
    claim_adjustment_total: "0.00",
    claim_adjustment_total_pr: "0.00",
    claim_cob: "0.00",
    claim_patres: "0.00",
    claim_paid: "",
    claim_balance: "0.00",
    sl_billed: "0.00",
    sl_discount: "0.00",
    sl_allowed: "0.00",
    sl_deduct: "0.00",
    sl_coins: "0.00",
    sl_copay: "0.00",
    sl_cob: "0.00",
    sl_patres: "0.00",
    sl_amount: "0.00",
    sl_paid: "0.00",
    sl_balance: "0.00",
    sl_total: "0.00",
    patient_id: "",
    patient_first_name: "",
    patient_middle_name: "",
    patient_last_name: "",
    patient_identifier_code: "",
    prior_auth_code: "",
    subscriber_id: "",
    subscriber_first_name: "",
    subscriber_middle_name: "",
    subscriber_last_name: "",
    subscriber_identifier_code: "",
    rendering_provider_id: "",
    rendering_provider_first_name: "",
    rendering_provider_last_name: "",
    rendering_provider_identifier_code: "",
    
    // ✅ Add edited_data at claim level
    edited_data: createEditedData(
      {
        
        patient_account_number: "",
        payer_claim_number: "",
        period_start: "",
        period_end: "",
        status_code: "",
        mrn: "",
        statement_number: "",
        statement_date: "",
        page_from: "",
        page_to: "",
        claim_billed: "",
        claim_discount: "0.00",
        claim_allowed: "0.00",
        claim_deduct: "0.00",
        claim_coins: "0.00",
        claim_copay: "0.00",
        adjustment_total: "0.00",
        claim_adjustment_total: "0.00",
        claim_adjustment_total_pr: "0.00",
        claim_cob: "0.00",
        claim_patres: "0.00",
        claim_paid: "",
        claim_balance: "0.00",
        sl_billed: "0.00",
        sl_discount: "0.00",
        sl_allowed: "0.00",
        sl_deduct: "0.00",
        sl_coins: "0.00",
        sl_copay: "0.00",
        sl_cob: "0.00",
        sl_patres: "0.00",
        sl_amount: "0.00",
        sl_paid: "0.00",
        sl_balance: "0.00",
        sl_total: "0.00",
        patient_first_name: "",
        patient_middle_name: "",
        patient_last_name: "",
        patient_identifier_code: "",
        prior_auth_code: "",
        subscriber_first_name: "",
        subscriber_middle_name: "",
        subscriber_last_name: "",
        subscriber_identifier_code: "",
        rendering_provider_first_name: "",
        rendering_provider_last_name: "",
        rendering_provider_identifier_code: "",
      },
      claimKeysToExclude
    ),

    service_lines: [
      {
        edited: true,
        service_line_id: "",
        from_date: "",
        to_date: "",
        code: "",
        procedure_type: "HC",
        modifier1: "",
        modifier2: "",
        modifier3: "",
        modifier4: "",
        rev_code: "",
        units: "",
        patres: "",
        billed: "",
        discount: "",
        allowed: "",
        deduct: "",
        coins: "",
        copay: "",
        cob: "",
        paid: "",
        balance: "",
        adjustments: [
          {
            edited: true,
            adjustment_id: "",
            pc: "",
            group_code: "",
            reason_code: "",
            rmk: "",
            amount: "",
            description: "",
            
            // ✅ Add edited_data at adjustment level
            edited_data: createEditedData(
              {
                pc: "",
                group_code: "",
                reason_code: "",
                rmk: "",
                amount: "",
                description: "",
              },
              adjustmentKeysToExclude
            ),
          },
        ],

        // ✅ Add edited_data at service line level
        edited_data: createEditedData(
          {
            from_date: "",
            to_date: "",
            code: "",
            procedure_type: "HC",
            modifier1: "",
            modifier2: "",
            modifier3: "",
            modifier4: "",
            rev_code: "",
            units: "",
            patres: "",
            billed: "",
            discount: "",
            allowed: "",
            deduct: "",
            coins: "",
            copay: "",
            cob: "",
            paid: "",
            balance: "",
          },
          serviceLineKeysToExclude
        ),
      },
    ],

    claim_adjustments: [
      {
        edited: true,
        pc: "",
        group_code: "",
        reason_code: "",
        rmk: "",
        amount: "",
        description: "",
        
        // ✅ Add edited_data at claim adjustment level
        edited_data: createEditedData(
          {
            pc: "",
            group_code: "",
            reason_code: "",
            rmk: "",
            amount: "",
            description: "",
          },
          claimAdjustmentKeysToExclude
        ),
      },
    ],
  },
];



// Keys to exclude
const slToExcludeAddsl = [];
const adjKeysToExcludeAdj = [];

export const initialServiceLine = [
  {
    edited: true,
    service_line_id: "",
    from_date: "",
    to_date: "",
    code: "",
    procedure_type: "HC",
    modifier1: "",
    modifier2: "",
    modifier3: "",
    modifier4: "",
    rev_code: "",
    units: "",
    patres: "",
    billed: "",
    discount: "",
    allowed: "",
    deduct: "",
    coins: "",
    copay: "",
    cob: "",
    paid: "",
    balance: "",
    
    // ✅ edited_data for service line
    edited_data: createEditedData(
      {
        from_date: "",
        to_date: "",
        code: "",
        procedure_type: "HC",
        modifier1: "",
        modifier2: "",
        modifier3: "",
        modifier4: "",
        rev_code: "",
        units: "",
        patres: "",
        billed: "",
        discount: "",
        allowed: "",
        deduct: "",
        coins: "",
        copay: "",
        cob: "",
        paid: "",
        balance: "",
      },
      slToExcludeAddsl
    ),

    adjustments: [
      {
        edited: true,
        adjustment_id: "",
        pc: "",
        group_code: "",
        reason_code: "",
        rmk: "",
        amount: "",
        
        // ✅ edited_data for adjustment
        edited_data: createEditedData(
          {
            pc: "",
            group_code: "",
            reason_code: "",
            rmk: "",
            amount: "",
          },
          adjKeysToExcludeAdj
        ),
      },
    ],
  },
];

const edited_dataPLB = {
  plb_adjustment_id: { old_val: null, error: true }, //null is for to make the yello color all time 
  npi: { old_val: null, error: true },
  plb_page: { old_val: null, error: true },
  reason: { old_val: null, error: true },
  patient_account_number: { old_val: null, error: true },
  plb_amt: { old_val: null, error: true }
};

export const getEmptyPlbAdjustment = {
  plb_adjustment_id: "",
  npi: "",
  plb_page: "1",
  edited:true,
  reason: "",
  patient_account_number: "",
  plb_amt: "",
  ...(window.location.pathname === NEW_QA_REVIEW ? { edited_data:edited_dataPLB } : {})
};

export const getEmptyAdjustment = (idKey) => ({
  [idKey]: "",
  pc: "",
  group_code: "",
  reason_code: "",
  rmk: "",
  amount: "",
  description: "",
  ...(window.location.pathname === NEW_QA_REVIEW
    ? {
      edited_data: createEditedData(
        {
          pc: "",
          group_code: "",
          reason_code: "",
          rmk: "",
          amount: "",
        },
        [] // optional: keys to exclude, e.g., ["adjustment_id"]
      ),
    }
    : {}),
});

export const createInitialClaim = (jobData, values) => {
    return [
        {
        patient: true,
        subscriber: true,
        rendering_provider: true,

        order: "",

        claim_id: "",
        patient_account_number: "",
        payer_claim_number: "",
        period_start: "",
        period_end: "",
        status_code: values?.transaction_type == "PATIENT_PAY_835" ? "1" : "",
        page_from: jobData?.is_large_batch_job && jobData?.header_range && jobData?.header_range?.length > 0 ? jobData?.header_range?.length + 2 : "1",
        page_to: jobData?.is_large_batch_job && jobData?.header_range && jobData?.header_range?.length > 0 ? jobData?.header_range?.length + 2 : "1",

        claim_billed: parseFloat(0).toFixed(2),
        claim_discount: parseFloat(0).toFixed(2),
        claim_allowed: parseFloat(0).toFixed(2),
        claim_deduct: parseFloat(0).toFixed(2),
        claim_coins: parseFloat(0).toFixed(2),
        claim_copay: parseFloat(0).toFixed(2),
        claim_cob: parseFloat(0).toFixed(2),
        claim_patres: parseFloat(0).toFixed(2),
        claim_paid: parseFloat(0).toFixed(2),
        claim_balance: parseFloat(0).toFixed(2),
        claim_adjustment_total: parseFloat(0).toFixed(2),
        claim_adjustment_total_pr: parseFloat(0).toFixed(2),

        sl_billed: parseFloat(0).toFixed(2),
        sl_discount: parseFloat(0).toFixed(2),
        sl_allowed: parseFloat(0).toFixed(2),
        sl_deduct: parseFloat(0).toFixed(2),
        sl_coins: parseFloat(0).toFixed(2),
        sl_copay: parseFloat(0).toFixed(2),
        sl_cob: parseFloat(0).toFixed(2),
        sl_patres: parseFloat(0).toFixed(2),
        sl_amount: parseFloat(0).toFixed(2),
        sl_paid: parseFloat(0).toFixed(2),
        sl_balance: parseFloat(0).toFixed(2),
        sl_total: parseFloat(0).toFixed(2),


        mrn: "",
        statement_number: "",
        statement_date: "",

        patient_id: "",
        patient_first_name: "",
        patient_middle_name: "",
        patient_last_name: "",
        patient_identifier_code: "",
        prior_auth_code: "",

        subscriber_id: "",
        subscriber_first_name: "",
        subscriber_middle_name: "",
        subscriber_last_name: "",
        subscriber_identifier_code: "",

        rendering_provider_id: "",
        rendering_provider_first_name: "",
        rendering_provider_last_name: "",
        rendering_provider_identifier_code: "",


        claim_adjustments: [
            {
            pc: "",
            group_code: "",
            reason_code: "",
            rmk: "",
            amount: "",
            claim_adjustment_id: "",
            },
        ],

        service_lines: [
            {
            order: "",
            service_line_id: "",
            from_date: "",
            to_date: "",
            code: "",
            procedure_type: "HC",
            modifier1: "",
            modifier2: "",
            modifier3: "",
            modifier4: "",
            rev_code: "",
            units: "",
            patres: "",
            billed: "",
            discount: "",
            allowed: "",
            deduct: "",
            coins: "",
            copay: "",
            cob: "",
            paid: "",

            balance: "",
            adjustments: [
                {
                adjustment_id: "",
                pc: "",
                group_code: "",
                reason_code: "",
                rmk: "",
                amount: "",
                },
            ],
            },
        ],
        },
    ];
};

export const getInitialClaim = (jobData = {}, values = {}, updates = {}) => {
  const pageValue = jobData?.is_large_batch_job && jobData?.header_range && jobData?.header_range?.length > 0 
    ? (jobData.header_range.length + 2).toString() 
    : "1";
    
  const statusCode = values?.transaction_type === "PATIENT_PAY_835" ? "1" : "";

  const defaultClaim = {
    patient: true,
    subscriber: true,
    rendering_provider: true,

    order: "",

    claim_id: "",
    patient_account_number: "",
    payer_claim_number: "",
    period_start: "",
    period_end: "",
    status_code: statusCode,
    page_from: pageValue,
    page_to: pageValue,

    claim_billed: "0.00",
    claim_discount: "0.00",
    claim_allowed: "0.00",
    claim_deduct: "0.00",
    claim_coins: "0.00",
    claim_copay: "0.00",
    claim_cob: "0.00",
    claim_patres: "0.00",
    claim_paid: "0.00",
    claim_balance: "0.00",
    claim_adjustment_total: "0.00",
    claim_adjustment_total_pr: "0.00",

    sl_billed: "0.00",
    sl_discount: "0.00",
    sl_allowed: "0.00",
    sl_deduct: "0.00",
    sl_coins: "0.00",
    sl_copay: "0.00",
    sl_cob: "0.00",
    sl_patres: "0.00",
    sl_amount: "0.00",
    sl_paid: "0.00",
    sl_balance: "0.00",
    sl_total: "0.00",


    mrn: "",
    statement_number: "",
    statement_date: "",

    patient_id: "",
    patient_first_name: "",
    patient_middle_name: "",
    patient_last_name: "",
    patient_identifier_code: "",
    prior_auth_code: "",

    subscriber_id: "",
    subscriber_first_name: "",
    subscriber_middle_name: "",
    subscriber_last_name: "",
    subscriber_identifier_code: "",

    rendering_provider_id: "",
    rendering_provider_first_name: "",
    rendering_provider_last_name: "",
    rendering_provider_identifier_code: "",

    claim_adjustments: [
      {
        pc: "",
        group_code: "",
        reason_code: "",
        rmk: "",
        amount: "",
        claim_adjustment_id: "",
      },
    ],

    service_lines: [
      {
        order: "",
        service_line_id: "",
        from_date: "",
        to_date: "",
        code: "",
        procedure_type: "HC",
        modifier1: "",
        modifier2: "",
        modifier3: "",
        modifier4: "",
        rev_code: "",
        units: "",
        patres: "",
        billed: "",
        discount: "",
        allowed: "",
        deduct: "",
        coins: "",
        copay: "",
        cob: "",
        paid: "",
        balance: "",
        adjustments: [
          {
            adjustment_id: "",
            pc: "",
            group_code: "",
            reason_code: "",
            rmk: "",
            amount: "",
          },
        ],
      },
    ],
  };

  // Merge updates with default claim, but handle arrays separately if provided in updates
  const updatedClaim = {
    ...defaultClaim,
    ...updates,
    claim_adjustments: updates.claim_adjustments || defaultClaim.claim_adjustments,
    service_lines: updates.service_lines || defaultClaim.service_lines,
  };

  return [updatedClaim];
};

export const getInitialServiceLine = (values = {}, updates = {}) => {
  const defaultServiceLine = {
    order: "",
    service_line_id: "",
    from_date: "",
    to_date: "",
    code: "",
    procedure_type: "HC",
    modifier1: "",
    modifier2: "",
    modifier3: "",
    modifier4: "",
    rev_code: "",
    units: "",
    patres: "",
    billed: "",
    discount: "",
    allowed: "",
    deduct: "",
    coins: "",
    copay: "",
    cob: "",
    paid: "",
    balance: "",
    adjustments: [
      {
        adjustment_id: "",
        pc: "",
        group_code: "",
        reason_code: "",
        rmk: "",
        amount: "",
      },
    ],
  };

  // Merge updates with default service line, handle adjustments array if provided
  const updatedServiceLine = {
    ...defaultServiceLine,
    ...updates,
    adjustments: updates.adjustments || defaultServiceLine.adjustments,
  };

  return [updatedServiceLine];
};

export const headerFieldNames = Object.keys(initialGridData).filter(
  key => key !== 'claims' && key !== 'plb_adjustments'
);


export const getPaymentMethodOptions = (transaction_type) => {
  if (transaction_type === "PAYMENT835") {
    return  paymentMethodOptions.filter(i=>(!["COR"].includes(i.value)));
  } else if (transaction_type === "PAYMENT835_LITE") {
    return paymentMethodOptions.filter(i=>["ACH","CHK","NON","VCP"].includes(i.value));
  } else if (transaction_type === "CORRESPONDENCE_835" ){
    return paymentMethodOptions.filter(i=>["COR"].includes(i.value));

  } else if (transaction_type === "PATIENT_PAY_835" ){
    return paymentMethodOptions.filter(i=>!["COR"].includes(i.value));

  }
  
  // Return empty array or default options if no match
  return [];
};

 export const patterns = {
    zipCode: /(^\d{5}$)|(^\d{5}-\d{4}$)|(^\d{5}\d{4}$)/,
    stateAbbrev: /^[a-zA-Z]{2}$/,
    npi: /^[0-9]{10}$/,
    tin: /^[0-9]{9}$/,
    code: /^[A-Za-z0-9]{5}$/,
    modifier: /^[A-Za-z0-9]{2,2}$/,
    revCode: /^[ A-Za-z0-9_@./#&+-]{3,4}$/,
    reasonCode: /^[a-zA-Z0-9]{0,3}$/,
    rmk: /^[A-Za-z][A-Za-z0-9]{0,4}$/,
    amount: /^[+-]?[0-9]{1,9}(?:\.[0-9]{1,2})?$/
  };

  export const keysToRemove = [
  'claim_patres',
  'claim_wise_message',
  'edited',
  'edited_data',
  'encounter',
  'fake_sl_patres',
  'first_837_claim',
  'is_save_as_draft',
  'job_id',
  'order',
  'sl_patres',
  'sl_total',
  'claim_balance',
  'auto_order',
  'adjustment_total',
  'claim_adjustment_total',
  'claim_adjustment_total_pr',
  'claim_adjustments',
  'service_lines',
  'payer_pulled_id',
  'plb_adjustment_id',
  'adjustments',
  'adjustment_id',
  'reasoncode_id',
];